import { Directive, ElementRef, AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { SlickUtilsService } from '../utils/slick-utils.service';

@Directive({
	selector: '[slick-drop-list-item]'
})
export class SlickDropListItemDirective {

	constructor(el: ElementRef) {
		const dropListEl = <HTMLElement>el.nativeElement;
		if (dropListEl.classList.contains("slick-drop-list-item") === false)
			dropListEl.classList.add("slick-drop-list-item");

	}
}